import Brace from "backbone.brace";
import Model from "../models/key-value";

const M = Model.extend({
  namedAttributes: {
    key: String,
  },
});

const Collection = Brace.Collection.extend({
  model: M,
});

export { Collection as default };
